import styled from 'styled-components'

export const ConfirmationContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: 20px;
	padding: 8px 0;
`

export const ConfirmationMessage = styled.div`
	margin: 0;
	font-size: 16px;
	color: #374151;
	line-height: 1.5;
	max-width: 400px;
	text-align: center;
`

export const DeletionTarget = styled.span`
	font-weight: bold;
	color: #111827;
`

export const Disclaimer = styled.div`
	font-size: 0.9em;
	color: #6b7280;
	font-style: italic;
	margin-top: 8px;
`

export const ConfirmationActions = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	width: 100%;
	margin-top: 8px;
`

export const ConfirmButton = styled.button<{ variant: 'danger' | 'warning' | 'info' }>`
	padding: 12px 24px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;
	border: none;
	min-width: 100px;

	${({ variant }) => {
		switch (variant) {
			case 'danger':
				return `
					background-color: #dc2626;
					color: white;

					&:hover {
						background-color: #b91c1c;
					}
				`
			case 'warning':
				return `
					background-color: #d97706;
					color: white;

					&:hover {
						background-color: #b45309;
					}
				`
			case 'info':
				return `
					background-color: #3b82f6;
					color: white;

					&:hover {
						background-color: #2563eb;
					}
				`
		}
	}}
`

export const CancelButton = styled.button`
	padding: 12px 24px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;
	border: 1px solid #d1d5db;
	background-color: white;
	color: #374151;
	min-width: 100px;

	&:hover {
		background-color: #f3f4f6;
	}
`
